import { ArrowDown, FileSearch } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ClosedLoopGraphic } from './ClosedLoopGraphic';

export function PlatformHero() {
  const scrollToSystem = () => {
    const el = document.getElementById('closed-loop-system');
    el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="pt-32 md:pt-40 pb-20 md:pb-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left — Copy */}
          <div className="max-w-xl">
            <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
              Revenue Integrity Platform
            </p>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight text-foreground mb-6">
              Revenue Integrity by Design, Not by Chance.
            </h1>

            <p className="text-lg text-muted-foreground leading-relaxed mb-10 max-w-lg">
              LINK is the industry's first Closed-Loop Procedure Revenue
              Integrity Platform. We eliminate the gap between what was
              authorized, what was performed, and what was billed.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                onClick={scrollToSystem}
                className="bg-cta hover:bg-cta/90 text-cta-foreground font-bold h-12 px-8 rounded-md"
              >
                Explore the Closed-Loop System
                <ArrowDown className="ml-2 h-4 w-4" />
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-border hover:bg-muted font-semibold h-12 px-8 rounded-md"
                asChild
              >
                <a href="/resources#security-trust">
                  <FileSearch className="mr-2 h-4 w-4" />
                  View Security Whitepaper
                </a>
              </Button>
            </div>
          </div>

          {/* Right — Graphic */}
          <div className="flex justify-center lg:justify-end">
            <ClosedLoopGraphic />
          </div>
        </div>
      </div>
    </section>
  );
}
